import React from 'react';
import PropTypes from 'prop-types';
import Mutation from '@dietlabs/components/src/Apollo/Mutation';
import DietSettingsGenerateDietMutation from './DietSettingsGenerateDietMutation';

class DietSettingsGenerateDietConnectorApollo extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };

    createGenerateDiet = mutate => async request => {
        const variables = {
            request,
        };

        const response = await mutate({
            variables,
        });

        return response;
    };

    render() {
        const { children } = this.props;

        return (
            <Mutation mutation={DietSettingsGenerateDietMutation}>
                {mutate =>
                    children({
                        generateDiet: this.createGenerateDiet(mutate),
                    })
                }
            </Mutation>
        );
    }
}

export default DietSettingsGenerateDietConnectorApollo;
